var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 408 c-16 -16 -15 -103 1 -117 8 -6 75 -12 168 -13 l154 -3 3 -41 c3 -40 2 -42 -31 -48 -49 -9 -72 -39 -72 -92 0 -60 29 -89 89 -89 64 0 86 24 86 91 0 44 -4 56 -25 72 -20 16 -25 29 -25 65 0 25 -6 49 -13 56 -8 6 -75 12 -168 13 l-154 3 0 45 0 45 155 0 155 0 3 -37 c2 -21 7 -38 13 -38 13 0 11 74 -3 88 -17 17 -319 17 -336 0z m363 -263 c14 -13 25 -36 25 -50 0 -14 -11 -37 -25 -50 -13 -14 -36 -25 -50 -25 -33 0 -75 42 -75 75 0 33 42 75 75 75 14 0 37 -11 50 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 95 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 95 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 95 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 222 c0 -21 5 -43 12 -50 15 -15 218 -17 218 -2 0 5 -45 11 -102 12 l-103 3 -3 38 c-4 49 -22 48 -22 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 102 c0 -21 5 -43 12 -50 15 -15 208 -17 208 -2 0 5 -44 11 -97 12 l-98 3 -3 38 c-4 49 -22 48 -22 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.df7f75b62314b8659453c3240a95c03e.svg";
export { ForwardRef as ReactComponent };